import React from "react";

export function TodosError({ error }) {
    return <p>Desesperate, hubo un error...</p>;
}